import { Button } from '@/components/ui/button.tsx';
import { useEffect, useState } from 'react';
import { ChevronUp } from 'lucide-react';

type TProps = {
	height?: number;
}

interface IState {
	isVisible: boolean;
}

const VARIABLES = {
	initState: {
		isVisible: false
	} as IState
};

const ButtonScrollTop = ({ height = 500 }: TProps) => {

	const [state, setState] = useState<IState>(VARIABLES.initState);

	useEffect(
		() => {
			const handleScroll = () => setState(l => ({ ...l, isVisible: window.scrollY > height }));
			window.addEventListener('scroll', handleScroll);
			return () => {
				window.removeEventListener('scroll', handleScroll);
			};
		},
		[]
	);

	const handleOnClickBtn = () =>
		window.scrollTo({
			behavior: 'smooth',
			top: 0
		});

	if (!state.isVisible) {
		return <></>;
	}

	return (
		<Button
			size='icon'
			onClick={handleOnClickBtn}
			title='Accéder en haut de la page'
			className={'fixed bottom-4 right-4'}>
			<ChevronUp className='h-4 w-4' />
		</Button>
	);

};

export default ButtonScrollTop;
